// extracted by mini-css-extract-plugin
module.exports = {"navbar":"PortalNavbar_navbar__3psHb","userMenuItem":"PortalNavbar_userMenuItem__Yb4Ei"};